/**
 * Auto-translate UI ("Translate to …"): dev/test/automation use `.env.*` via webpack;
 * production uses `window.env` from `public/index.html` (deploy-time `%%` substitution).
 */
export const isAutoTranslateFeatureEnabled = (() => {
  if (
    process.env.NODE_ENV === 'development' ||
    process.env.NODE_ENV === 'test' ||
    process.env.NODE_ENV === 'automation'
  ) {
    return process.env.AUTO_TRANSLATE_FEATURE === 'true';
  }
  if (typeof window !== 'undefined') {
    const v = (window as any).env?.AUTO_TRANSLATE_FEATURE;
    if (v !== undefined) {
      return v === 'true';
    }
  }
  return false;
})();
